const PainPointSection = () => {
    return (
        <section className="basic-area section-animate" style={{ backgroundColor: "#fff", padding: "20px 0" }}>
            <div className="container">
                <h2 style={{ textAlign: "center", marginBottom: "30px", fontSize: "36px", fontWeight: "600", color: "#3d3d3d" }}>
                    Tired of...
                </h2>
                <div style={{ maxWidth: "800px", margin: "0 auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "15px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "12px" }}>
                            <span style={{ fontSize: "24px", color: "#000000", flexShrink: 0, fontWeight: "bold" }}>✗</span>
                            <div>
                                <strong style={{ fontSize: "20px", color: "#3d3d3d" }}>Paper surveys that never get filled out?</strong>
                                <p style={{ color: "#6c6c6c", marginTop: "8px", fontSize: "16px" }}>
                                    Low response rates mean you're missing critical customer insights.
                                </p>
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "15px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "12px" }}>
                            <span style={{ fontSize: "24px", color: "#000000", flexShrink: 0, fontWeight: "bold" }}>✗</span>
                            <div>
                                <strong style={{ fontSize: "20px", color: "#3d3d3d" }}>Generic feedback that doesn't help?</strong>
                                <p style={{ color: "#6c6c6c", marginTop: "8px", fontSize: "16px" }}>
                                    Vague comments like "nice place" don't tell you what to improve.
                                </p>
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "15px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "12px" }}>
                            <span style={{ fontSize: "24px", color: "#000000", flexShrink: 0, fontWeight: "bold" }}>✗</span>
                            <div>
                                <strong style={{ fontSize: "20px", color: "#3d3d3d" }}>Expensive survey tools with confusing dashboards?</strong>
                                <p style={{ color: "#6c6c6c", marginTop: "8px", fontSize: "16px" }}>
                                    Complex software shouldn't cost you time and money you don't have.
                                </p>
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "15px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "12px" }}>
                            <span style={{ fontSize: "24px", color: "#000000", flexShrink: 0, fontWeight: "bold" }}>✗</span>
                            <div>
                                <strong style={{ fontSize: "20px", color: "#3d3d3d" }}>Waiting weeks to understand customer sentiment?</strong>
                                <p style={{ color: "#6c6c6c", marginTop: "8px", fontSize: "16px" }}>
                                    By the time you analyze feedback, the moment to act is already gone.
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div style={{ 
                        textAlign: "center", 
                        marginTop: "10px", 
                        padding: "40px", 
                    }}>
                        <h2 style={{fontSize: "36px"}}>
                            Katalife Is Here
                        </h2>
                        <p style={{ fontSize: "18px", opacity: 0.9 }}>
                            <br></br>Get real, actionable feedback in minutes with QR codes your customers actually want to scan.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PainPointSection;
